module.exports = __webpack_public_path__ + "static/media/Рассадин А., Рубцов М., Бугров В. (ММ).6d727b14.pdf";